import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import { $themeConfig } from 'src/app/core/theme.config';


@Injectable({
  providedIn: 'root',
})
export class RestService {
  //private apiEndpoint = 'http://10.0.5.6/api/';
  REST_ROOT = $themeConfig.restRoot;

  private get headers(): HttpHeaders {
    const token = localStorage.getItem('token') || '';
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'q=0.8;application/json;q=0.9',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    });
  }

  constructor(private http: HttpClient) {}

  private handleError(error: any): Observable<never> {
    return throwError(error || error);
  }

  private extractData(res: any) {
    const body = res;
    return body || {};
  }

  getService(url: string): Observable<any> {
    //console.log('headers', this.headers);
    return this.http
      .get(url, { headers: this.headers })
      .pipe(
        catchError(this.handleError),
      );
  }


  getAjaxData(url: string): Observable<any[]> {
    return this.http
      .get(url, { headers: this.headers })
      .pipe(
        map((responseData: any) => (responseData.data || responseData)),
        catchError(this.handleError)
      );
  }

  getServiceWithDynamicQueryTerm(url: string, key: string, val: string): Observable<any> {
    return this.http
      .get(`${url}/?${key}=${val}`, { headers: this.headers })
      .pipe(
        catchError(this.handleError),
      );
  }

  getServiceWithFixedQueryString(url: string, param: any): Observable<any> {
    const params = new HttpParams().set('query', param);
    return this.http
      .get(url, { headers: this.headers, params })
      .pipe(
        catchError(this.handleError),
      );
  }

  getServiceWithComplexObjectAsQueryString(url: string, param: any): Observable<any> {
    const params = new HttpParams();
    for (const key in param) {
      if (param.hasOwnProperty(key)) {
        const val = param[key];
        params.set(key, val);
      }
    }
    return this.http
      .get(url, { headers: this.headers, params })
      .pipe(
        catchError(this.handleError),
      );
  }

  createService(url: string, param: any): Observable<any> {
    const body = JSON.stringify(param);
    return this.http
      .post(url, body, { headers: this.headers })
      .pipe(
        catchError(this.handleError),
      );
  }

  updateService(url: string, param: any): Observable<any> {
    const body = JSON.stringify(param);
    return this.http
      .put(url, body, { headers: this.headers })
      .pipe(
        catchError(this.handleError),
      );
  }


  updateProfileWithoutFormData(url: string, payload: any): Observable<any> {
    return this.http.post(url, payload, { headers: this.headers }).pipe(
      catchError(this.handleError)
    );
  }

  patchService(url: string, param: any): Observable<any> {
    const body = JSON.stringify(param);
    return this.http
      .patch(url, body, { headers: this.headers })
      .pipe(
        catchError(this.handleError),
      );
  }

  deleteService(url: string, param: any): Observable<any> {
    const body = JSON.stringify(param);
    return this.http
      .put(url, body, { headers: this.headers })
      .pipe(
        catchError(this.handleError),
      );
  }

/*  deleteService(url: string, param: any): Observable<any> {
    const params = new HttpParams();
    for (const key in param) {
      if (param.hasOwnProperty(key)) {
        const val = param[key];
        params.set(key, val);
      }
    }
    return this.http
      .delete(url, { headers: this.headers, params })
      .pipe(
        catchError(this.handleError),
      );
  }*/

  deleteServiceWithId(url: string, key: string, val: string): Observable<any> {
    return this.http
      .delete(`${url}/?${key}=${val}`, { headers: this.headers })
      .pipe(
        catchError(this.handleError),
      );
  }
}
